"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = {
  PROGRAM: 'Program',
  PIPELINE: 'Pipeline',
  ASSIGNMENT: 'Assignment',
  COMMAND: 'Command',
  INTERPOLATION: 'Interpolation',
  FUNCTION: 'Function',
  OPTION: 'Option',
  ARGUMENT: 'Argument',
  VARIABLE: 'Variable'
};
exports.default = _default;